// DEPENDENCIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// INNER IMPORTS
import {formatMusicStyles, getDate, getIamACat} from '../../utils';
import { BAND, MUSICIAN, SERVICE, LIVE_MUSIC } from '../../consts';

// styles
import './PinToolTipNew.css';

// svg and icons import
// import scopWhiteTxtSVG from '../inlineSVGs/scopWhiteTxtSVG';
// import locationBlueSVG from '../inlineSVGs/locationBlueSVG';
// import clockSVG from '../inlineSVGs/clockSVG';

import { capitalize, capitalizeAll } from '../../utils';
import { clientMedia } from "../../Config/Settings";
import SVGInline from "react-svg-inline";
import arrowSideSVG from "../inlineSVGs/arrowSideSVG";

class PinToolTip extends Component {
    constructor() {
        super();

        this.state = {
            currentPin: 0
        }
    }

    openTypePinModal(pin) {
        this.props.openPinModal(pin);
    }

    getImageURL(pin) {
        if (!pin.images[0] || !pin.images[0].thumbnail) {
            return `url('${clientMedia()}/img/logos/make-logo.png')`;
        }

        return `url('${pin.images[0].thumbnail}')`
    }

    getTitle(pin) {
        if (!pin.name) return;

        if (pin.name.length < 30) return pin.name;

        return `${pin.name.substr(0, 30)}...`
    }

    getLabel(pin) {
        if (!this.props || !pin) return;

        if (pin.type === LIVE_MUSIC) return getDate(pin.date, pin.time);

        if (pin.type === SERVICE) return;

        // if (pin.iWeAre && pin.iWeAre.includes('band')) {
        //     return `${getIamACat(pin.iWeAre, this.props.datatypes.categories[pin.type])}`
        // }

        return `${getIamACat(pin.iWeAre, this.props.datatypes.categories[pin.type])}`
    }

    getFooterText(pin) {
        if (!pin) return;

        if (pin.type === LIVE_MUSIC) return this.getLiveMusicFooter(pin);
        if (pin.type === SERVICE) return this.getServiceFooter(pin);
        if (pin.type === BAND) return 'אנחנו פה!';
        if (pin.type === MUSICIAN) return 'אני פה!';
    }

    getServiceFooter(pin) {
        const categoryObj = this.props.datatypes.categories.service.find(c => c.name === pin.category) || {};
        const text = capitalizeAll(categoryObj.text) || '';

        if (text.length > 16) return `${text.substr(0, 16)}...`;

        return text;
    }

    getLiveMusicFooter(pin) {
        const text = capitalizeAll(pin.subCategories.join(', '));

        if (text.length > 16) return `${text.substr(0, 16)}...`;

        return text;
    }

    forceRefreshDom() {
        const domGoogleElement = window.document.querySelector('.gm-style-iw.gm-style-iw-c');
        if (!domGoogleElement) return;

        domGoogleElement.style.maxWidth = '120px';
    }

    handleArrowClick(e, side) {
        e.stopPropagation();


        if (side === 'L') return this.setState({ currentPin: this.state.currentPin > 0 ? this.state.currentPin - 1 : 0});

        this.setState({
            currentPin: this.state.currentPin < this.props.pinsList.length - 1 ? this.state.currentPin + 1 : this.props.pinsList.length - 1
        })

    }

    renderMultiPinHeader(pinsList) {
        if (!pinsList || pinsList.length < 2) return null;

        return (
            <div className={`tool-tip-page-header ${pinsList[0].type}`} onClick={e => e.stopPropagation()}>
                <div
                    className={`arrow right`}
                    onClick={e => this.handleArrowClick(e, 'R')}
                >
                    <SVGInline className="arrow-side-icon" svg={arrowSideSVG} component="i"/>
                </div>

                <div className="header-text">{`${this.state.currentPin + 1}/${pinsList.length}`}</div>

                <div
                    className={`arrow left`}
                    onClick={e => this.handleArrowClick(e, 'L')}
                >
                    <SVGInline className="arrow-side-icon" svg={arrowSideSVG} component="i"/>
                </div>
            </div>
        )
    }

    renderMultiPin(pinsList) {
        const pinShowing = pinsList[this.state.currentPin];

        if (!pinShowing) return null;

        return (
            <div
                id="iw-container"
                onClick={() => this.openTypePinModal(pinShowing)}
            >

                {this.renderMultiPinHeader(pinsList)}

                <div
                    className="iw-content"
                    style={{
                        backgroundImage: this.getImageURL(pinShowing)
                    }}
                >
                    <div className="iw-title">{this.getTitle(pinShowing)}</div>
                    <div className={`iw-label ${pinShowing.type}`}>
                        {this.getLabel(pinShowing)}
                    </div>
                </div>
                <div>
                    <div className={`iw-footer ${pinShowing.type}`}>
                        <p>{capitalizeAll(this.getFooterText(pinShowing))}</p>
                    </div>
                </div>
            </div>
        )
    }

    render() {

        if (!this.props || !this.props.pinsList || this.props.pinsList.length < 1) return null;

        return (
            <div className="pin-tip-carousel-wrapper" style={{display: 'flex'}}>
                {this.renderMultiPin(this.props.pinsList)}
            </div>
        )
    }
}

PinToolTip.propTypes = {
    datatypes: PropTypes.object,
    isNotHovering: PropTypes.func,
    isHovering: PropTypes.func,
    openPinModal: PropTypes.func,
    pinsList: PropTypes.array
};

export default PinToolTip;



// WEBPACK FOOTER //
// ./src/Components/Main/PinToolTip.js